import React, { useState } from 'react'
import { sortingOptionsObject } from './helpers';
import { ReactComponent as ArrowDown } from "@svgs/arrow-down.svg"
import { onEnterKeyPress } from '@src/utils/general';

const ProductSort = ({sortingOptions, setSortingOptions}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectedSortOption = sortingOptionsObject[sortingOptions];

  return (
    <div className='w-full border-1 relative border-solid border-gray rounded-xl mb-5 select-none h-fit flex flex-col'>
      <div className='flex p-5 cursor-pointer justify-between items-center' onClick={() => setIsOpen((prevState) => !prevState)} onKeyDown={(e) => onEnterKeyPress(e, () => setIsOpen((prevState) => !prevState))} role='button' aria-label={`Sort Items. Currently sorting by ${selectedSortOption}`} tabIndex={0} aria-expanded={isOpen}>
        <p><b>Sort:</b> {selectedSortOption}</p>
        <ArrowDown className={`fill-darker-gray`} />
      </div>

      <div className={`${isOpen ? 'max-h-64 visible' : 'max-h-0 invisible'} transition-all duration-300 flex flex-col overflow-hidden absolute z-10 w-full left-0 top-full translate-y-2.5 rounded-xl border-1 border-gray`} >
        {Object.keys(sortingOptionsObject).map((option, index) => (
          <div 
            key={index} 
            onClick={() => setSortingOptions(option)}
            onKeyDown={(e) => onEnterKeyPress(e, () => setSortingOptions(option))}
            aria-label={`Based on ${sortingOptionsObject[option]} ${sortingOptions === option ? ', selected' : ''}`}
            tabIndex={isOpen ? 0 : -1}
            className={`cursor-pointer first:border-t-0 border-t-1 border-solid border-gray p-2.5 hover:bg-light-gray duration-200 ${sortingOptions === option ? 'bg-light-gray' : 'bg-white'}`}
          >
            <p>{sortingOptionsObject[option]}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductSort